module.exports = __webpack_public_path__ + "img/school.3df2d66e.jpg";